import type { CollectionExport } from '@/types/global';

type RemoteCollection = {
	collectionId: string;
	collectionObject: string;
	collectionSiteId: string;
	isSynced: boolean;
	collectionDate: number;
	createdOn: number;
	updatedAt: number;
	status: string;
	createdById: string;
};

export const remotecollections: CollectionExport<RemoteCollection> = {
	schema: {
		title: 'remotecollections',
		version: 10,
		primaryKey: 'collectionId',
		type: 'object',
		properties: {
			collectionId: {
				type: 'string',
				maxLength: 30
			},
			collectionObject: {
				type: 'string'
			},
			collectionSiteId: {
				type: 'string'
			},
			isSynced: {
				type: 'boolean'
			},
			collectionDate: {
				type: 'datetime'
			},
			createdOn: {
				type: 'datetime'
			},
			updatedAt: {
				type: 'datetime'
			},
			status: {
				type: 'string'
			},
			createdById: {
				type: 'string'
			}
		},
		encrypted: [ 'collectionObject' ]
	},
	migrationStrategies: {
		8: function( oldDoc ) {
			return oldDoc;
		},
		9: function( oldDoc ) {
			// adding created date, defaulting to collection date if not already defined
			oldDoc.createdOn = oldDoc.collectionDate;

			return oldDoc;
		},
		10: function( oldDoc ) {
			oldDoc.createdById = oldDoc?.collectionObject?.createdById;

			return oldDoc;
		}
	}
};
